import { CollectionGroupName } from "@super-real/types";
import { collectionGroup } from "firebase/firestore";
import { db } from "../consts/FIREBASE";

export function getCollectionGroupRef(
  collectionGroupName: CollectionGroupName
) {
  return collectionGroup(db, collectionGroupName);
}
